import React from "react";
import { FaPhoneVolume, FaBullhorn, FaUsers, FaBuilding, FaLightbulb, FaUserTie, FaCheck, FaRocket } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useInView } from "../../../hooks/useInView";
import SkeletonCard from "../../../components/SkeletonCard/SkeletonCard";

const HomeTwoPartnership = () => {
  const [ref, isInView] = useInView({ threshold: 0.1 });
  const models = [
    {
      icon: <FaPhoneVolume />,
      title: "Inbound Sales Partner",
      description: "Convert high-intent inbound leads into sales with our trained telecom specialists",
      features: ["Lead qualification", "Sales conversion", "Full call recording"],
      color: "blue-2-color"
    },
    {
      icon: <FaBullhorn />,
      title: "Outbound Telemarketing",
      description: "Proactive outreach to qualified prospects with TCPA-compliant calling practices",
      features: ["Targeted campaigns", "Compliance-first", "Scripted excellence"],
      color: "pink-color"
    },
    {
      icon: <FaUsers />,
      title: "Hybrid Sales Team",
      description: "Best of both worlds — combining inbound and outbound strategies for maximum reach",
      features: ["Multi-channel approach", "Scalable teams", "Consistent results"],
      color: "green-4-color"
    },
    {
      icon: <FaBuilding />,
      title: "Hosted Contact Center",
      description: "Full-service contact center infrastructure with state-of-the-art technology",
      features: ["Cloud-based platform", "Real-time reporting", "24/7 operations"],
      color: "orange-color"
    },
    {
      icon: <FaLightbulb />,
      title: "Lead-Only Provider",
      description: "We generate and deliver qualified, consent-based leads ready for your team",
      features: ["SEO & paid ads", "Social media leads", "Pre-qualified data"],
      color: "blue-2-color"
    },
    {
      icon: <FaUserTie />,
      title: "Dedicated Agents",
      description: "Exclusive team members working solely for your brand with complete focus",
      features: ["Brand immersion", "Dedicated training", "Your team extension"],
      color: "pink-color"
    },
  ];

  return (
    <>
      <section ref={ref} className="services__area pt-115 pb-80 grey-bg glassmorphic-section">
        <div className="container">
          {/* Section Header */}
          <div className="row mb-60">
            <div className="col-xl-8 offset-xl-2">
              <div className="section__title section__title-3 text-center">
                <span>Flexible Engagement</span>
                <h2>Partnership Models That Scale With You</h2>
                <p className="mt-20" style={{ fontSize: '16px', lineHeight: '1.8' }}>
                  Whether you need inbound support, outbound sales, or a complete contact center solution —
                  we offer flexible engagement models designed to fit your specific business needs and growth goals.
                </p>
              </div>
            </div>
          </div>

          {/* Partnership Models Grid */}
          <div className="row">
            {!isInView ? (
              // Show skeleton loaders while not in view
              Array.from({ length: 6 }).map((_, index) => (
                <div key={index} className="col-xl-4 col-lg-6 col-md-6">
                  <SkeletonCard type="service" />
                </div>
              ))
            ) : (
              // Show actual content when in view
              models.map((model, index) => (
                <div key={index} className="col-xl-4 col-lg-6 col-md-6">
                  <div
                    className="services__item white-bg mb-30 content-loaded"
                    style={{ borderRadius: '20px', padding: "20px", border: '1px solid #e6e6e6', minHeight: '400px' }}
                  >
                    <div className="services__icon mb-25">
                      <i className={model.color} style={{ fontSize: '52px' }}>
                        {model.icon}
                      </i>
                    </div>
                    <h3 className="mb-20">{model.title}</h3>
                    <p className="mb-25" style={{ minHeight: '60px' }}>
                      {model.description}
                    </p>
                    <ul className="services__list">
                      {model.features.map((feature, idx) => (
                        <li key={idx} className="mb-10">
                          <i className="green-4-color mr-10" style={{ fontSize: '14px' }}>
                            <FaCheck />
                          </i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Bottom CTA Section */}
          <div className="row mt-50">
            <div className="col-xl-10 offset-xl-1">
              <div
                className="services__bottom-content text-center white-bg"
                style={{
                  padding: '50px 40px',
                  borderRadius: '28px',
                  border: '1px solid rgba(87, 73, 255, 0.1)',
                  boxShadow: '0 8px 32px rgba(87, 73, 255, 0.08)'
                }}
              >
                <div className="mb-25">
                  <i className="blue-2-color" style={{ fontSize: '56px' }}>
                    <FaRocket />
                  </i>
                </div>
                <h3 className="mb-25" style={{ fontSize: '28px', fontWeight: '700' }}>We're Flexible — and Built to Scale</h3>
                <p className="mb-35" style={{ fontSize: '17px', maxWidth: '750px', margin: '0 auto 35px', lineHeight: '1.8', opacity: '0.9' }}>
                  No matter where you are in your growth journey, we can customize a partnership model
                  that delivers results without operational friction. Start small or go big — we scale with you.
                </p>
                <Link
                  to="/contact-us"
                  className="z-btn z-btn-border"
                  style={{
                    padding: '16px 40px',
                    borderRadius: '12px',
                    fontSize: '16px',
                    fontWeight: '600',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    minWidth: '220px'
                  }}
                >
                  Discuss Your Needs
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeTwoPartnership;
